import React, { useMemo } from "react";
import PropTypes from "prop-types";

import CasinoSearch from "./search";
import CasinoProviders from "./providers";

const CasinoTopBar = ({ filter, onChange }) => {
    const selectedProviders = useMemo(() => filter.provider ? filter.provider.split(',') : [], [filter]);

    const onSearchChange = text => onChange({ ...filter, search: text || null });
    const onProviderChange = providers => onChange({ ...filter, provider: providers.join(',') });

    return <div className="filter-casino-row">
        <CasinoSearch onSubmit={onSearchChange} />
        <CasinoProviders selected={selectedProviders} onChange={onProviderChange} />
    </div>
};

CasinoTopBar.propTypes = {
    filter: PropTypes.object.isRequired,
    onChange: PropTypes.func,
};

export default CasinoTopBar;